import { render, staticRenderFns } from "./NoAnswerNil.vue?vue&type=template&id=89d9bd58&"
import script from "./NoAnswerNil.vue?vue&type=script&lang=js&"
export * from "./NoAnswerNil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports